// @vendors
const React = require('react');
const PropTypes = require('prop-types');
const { connect } = require('react-redux');
const PureRenderMixin = require('react-addons-pure-render-mixin');
// @commons
const { LoadingSection } = require('commonsComponents/loadingSection');
const { OKCover } = require('commonsComponents/OKCover');
const { OKHeaderSubPage } = require('commonsComponents/OKHeaderSubPage');
const { OKSectionBox } = require('commonsComponents/OKSectionBox');
// @components
const CardRewardsSideBar = require('components/cards/cardRewardsSideBar/cardRewardsSideBar');
const { CallMeBack } = require('components/callMeBack/callMeBack');
const { CardRewards } = require('components/cards/cardRewards/cardRewards');
// @helpers
const { formatText } = require('core/i18n').i18n;

class CardRewardsView extends React.Component {
    constructor(props) {
        super(props);
        this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);
    }

    render() {
        const { match: { params: { cardId } }, immCardRewards, immCards } = this.props;
        const immCard = immCards.getIn(['byId', cardId], null);
        let content;

        if (!!immCard) {
            const type = immCard.get('type');
            const cardName = immCard.getIn(['alias', 'current'], '')
            const subtitleLeft = formatText(`cards-${type}`);
            const subtitleRight = cardName;
            const mappingBreadcrumb = [
                {
                    text: formatText('breadcrumb-cards'),
                    url: '/myprofile/cards'
                },
                {
                    text: cardName,
                    url: `/myprofile/cards/${cardId}/movements`
                },
                {
                    text: formatText('breadcrumb-breadcrumb_cardRewards'),
                    url: ''
                }
            ];

            content = (
                <div>
                    <div className="container-fluid">
                        <div className="row">
                            <OKCover size="medium" section="cards" customClass="col-xs-12">
                                <OKHeaderSubPage
                                    breadcrumbConfig={mappingBreadcrumb}
                                    subtitleLeft={subtitleLeft}
                                    subtitleRight={subtitleRight}
                                    finalTitle={formatText('cardRewards-cardRewards_title')}
                                >
                                </OKHeaderSubPage>
                            </OKCover>
                        </div>
                    </div>
                    <div className="grid-view__body">
                        <div className="container-fluid">
                            <div className="row grid-view--content-position-negative">
                                <div className="col-xs-12 col-md-8">
                                    <div className="row">
                                        <div className="col-md-12">
                                            <OKSectionBox>
                                                <CardRewards cardId={cardId} />
                                            </OKSectionBox>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-xs-12 col-md-4">
                                    <div className="row">
                                        <div className="hidden-xs hidden-sm col-md-12 grid-view--variable-cell-separation">
                                            <CardRewardsSideBar immCardRewards={immCardRewards} />
                                        </div>
                                        <div className="col-xs-12 col-sm-6 col-md-12 grid-view--fix-cell-separation">
                                            <CallMeBack pageTitle={formatText('breadcrumb-cards')} hasEntrance={false}/>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            );
        } else {
            content = <LoadingSection />;
        }

        return content;
    }
}

CardRewardsView.propTypes = {
    immCardRewards: PropTypes.object.isRequired,
    immCards: PropTypes.object.isRequired,
    match: PropTypes.object.isRequired,
};

module.exports.constructor = CardRewardsView;
module.exports.CardRewardsView = connect(
    state => ({
        immCardRewards: state.cardRewards,
        immCards: state.cards,
    })
)(CardRewardsView);
